const BASE_URL = "https://v1api.gooddiy.com/";

function getToken(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function goToLogin() {
  const url = window.location.href;
  if (url.indexOf("pages/account") !== -1) {
    return true;
  }
  return false;
}

// 生成UUID
function generateUUIDv4() {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);

  // 设置 UUID 版本为 4
  array[6] = (array[6] & 0x0f) | 0x40;
  // 设置 UUID 变体为 RFC 4122
  array[8] = (array[8] & 0x3f) | 0x80;

  const toHex = (num) => {
    return ("00" + num.toString(16)).slice(-2);
  };

  return [
    toHex(array[0]) + toHex(array[1]) + toHex(array[2]) + toHex(array[3]),
    toHex(array[4]) + toHex(array[5]),
    toHex(array[6]) + toHex(array[7]),
    toHex(array[8]) + toHex(array[9]),
    toHex(array[10]) +
      toHex(array[11]) +
      toHex(array[12]) +
      toHex(array[13]) +
      toHex(array[14]) +
      toHex(array[15]),
  ].join("-");
}

// 请求错误上报
function reportRequestError(errorInfo) {
  if (
    errorInfo.indexOf("api/v1/profile") !== -1 &&
    errorInfo.indexOf("Authorization is invalid") !== -1
  )
    return;
  const uuid = generateUUIDv4();
  const url = "api/v1/bug/report";
  const params = {
    uuid: uuid,
    url: window.location.href,
    type: "http",
    data: errorInfo,
    env: navigator.userAgent,
  };
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  };
  fetch(`${BASE_URL}${url}`, config);
}

function showFailMessage() {
  const message = document.querySelector("#failMsg"); //添加成功
  message?.classList.remove("hidden");
  var timer = setTimeout(() => {
    clearTimeout(timer);
    message?.classList.add("hidden");
  }, 2000);
}
/**
 * @param {string} url - 请求的 URL
 * @param {string} method - 请求的方法，例如 'GET' 或 'POST'
 * @param {Object} params - 请求的参数
 * @returns {Promise<any>} - 返回一个 Promise，解析为响应数据
 */
async function fetchRequest(url, method = "GET", params = {}) {
  const token = JSON.parse(getToken("token"));
  let newUrl = url.includes("https://") ? url : `${BASE_URL}${url}`;
  // console.log(token);
  const options = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  // 如果是 POST 请求，添加请求体
  if (method.toUpperCase() === "POST") {
    options.body = JSON.stringify(params);
  } else if (method.toUpperCase() === "GET") {
    // 如果是 GET 请求，将参数添加到 URL 中
    const queryString = new URLSearchParams(params).toString();
    newUrl += `?${queryString}`;
  }

  try {
    const response = await fetch(newUrl, options);
    // 检查响应是否成功
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // 解析 JSON 数据
    const data = await response.json();
    if (data.code === 200) {
      return { data: data.data, error: false };
    } else if (data.code === 401 && goToLogin()) {
      window.location.href = "/account/register";
    } else {
      reportRequestError(`${newUrl}: ${data.msg}`);
      return { data: null, error: true, msg: data.msg };
    }
  } catch (error) {
    showFailMessage();
    reportRequestError(`${newUrl}: ${error}`);
    console.error("Fetch request failed:", error);
    throw error; // 重新抛出错误以便调用者处理
  }
}

async function getStorefrontAccessToken() {
  const token = localStorage.getItem("storefrontAccessToken");
  if (!token) {
    const response = await fetchRequest(
      `${BASE_URL}api/v1/public-token`,
      "POST"
    );
    if (response) {
      localStorage.setItem("storefrontAccessToken", response.data);
      return response.data;
    }
  } else {
    return token;
  }
}

/**
 * 封装的 GraphQL 请求函数
 * @param {string} query - GraphQL 查询字符串
 * @param {Object} variables - 查询变量
 * @returns {Promise<any>} - 返回一个 Promise，解析为响应数据
 */
async function fetchGraphQL(query, variables = {}) {
  const shopifyDomain = "namenecklaceflurry.myshopify.com";
  const shopifyApiDate = "2025-07";
  const url = `https://${shopifyDomain}/api/${shopifyApiDate}/graphql`;
  const storefrontAccessToken = await getStorefrontAccessToken();
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    // 检查响应是否成功
    if (!response.ok) {
      const error = await response.json();
      reportRequestError(err.message);
      throw new Error(
        `GraphQL error: ${error.errors.map((err) => err.message).join(", ")}`
      );
    }

    // 解析 JSON 数据
    const data = await response.json();
    return data.data;
  } catch (error) {
    showFailMessage();
    reportRequestError(error);
    console.error("Fetch request failed:", error);
    throw error; // 重新抛出错误以便调用者处理
  }
}

/**
 * 封装的 connect 请求函数
 * @param {string} url - 请求的 URL
 * @param {string} method - 请求的方法，例如 'GET' 或 'POST'
 * @param {Object} params - 请求的参数
 * @returns {Promise<any>} - 返回一个 Promise，解析为响应数据
 */
async function fetchConnect(url, method = "GET", params = {}) {
  const token = JSON.parse(getToken("token"));
  let newUrl = url.includes("https://") ? url : `${BASE_URL}${url}`;
  const options = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  // 如果是 POST 请求，添加请求体
  if (method.toUpperCase() === "POST") {
    options.body = JSON.stringify(params);
  } else if (method.toUpperCase() === "GET") {
    // 如果是 GET 请求，将参数添加到 URL 中
    const queryString = new URLSearchParams(params).toString();
    newUrl += `?${queryString}`;
  }

  const response = await fetch(newUrl, options);
  // 解析 JSON 数据
  const data = await response.json();
  if (response.status === 200) {
    return { data: data, error: false };
  } else if (response.status === 401 && goToLogin()) {
    window.location.href = "/account/register";
  } else {
    showFailMessage();
    reportRequestError(`${newUrl}: ${JSON.stringify(data)}`);
    return { data: null, error: true, msg: data.message };
  }
}

